<!--
  REV-21353 — Pure View: Mandats-Navigation. Gerüst 1:1 aus dem AWF-Prototyp
  (REV-21353-context/awf-navigation-snippet.html). Selektor-Contract via data-testid + aria.
  Precedence: loading > error > empty > filled. OnPush, *ngIf/*ngFor, kein async-pipe.
-->
<aside class="ham-navigation-bar pnav" [class.is-collapsed]="collapsed" data-testid="nav-bar">
    <div class="pnav-topbar">
        <button
            type="button"
            class="pnav-collapse"
            data-testid="nav-collapse-toggle"
            [title]="collapsed ? 'Navigation einblenden' : 'Navigation ausblenden'"
            [attr.aria-label]="collapsed ? 'Navigation einblenden' : 'Navigation ausblenden'"
            [attr.aria-expanded]="!collapsed"
            (click)="onToggleCollapse()"
        >
            <lucide-icon
                [name]="collapsed ? 'panel-left-open' : 'panel-left-close'"
                [size]="16"
                aria-hidden="true"
            ></lucide-icon>
        </button>
    </div>

    <div class="pnav-head" data-testid="nav-header" *ngIf="mandate && !collapsed">
        <div class="pnav-mandant">{{ mandate.mandantName }}</div>
        <div class="pnav-period">{{ mandate.fiscalYearLabel }}</div>
    </div>

    <!-- loading -->
    <div class="pnav-loading" data-testid="nav-loading" *ngIf="loading">
        <div class="pnav-skeleton" *ngFor="let s of [1, 2, 3, 4, 5, 6]" aria-hidden="true"></div>
    </div>

    <!-- error -->
    <div class="pnav-error" data-testid="nav-error" *ngIf="!loading && error">
        Navigation konnte nicht geladen werden.
    </div>

    <!-- empty -->
    <div class="pnav-empty" data-testid="nav-empty" *ngIf="!loading && !error && isEmpty">Keine Module verfügbar.</div>

    <!-- filled -->
    <div class="pnav-areas" *ngIf="!loading && !error && !isEmpty">
        <div class="pnav-area-group" *ngFor="let m of modules; trackBy: trackByModuleId">
            <!-- The row alone, so the action can be centred on it rather than on the row plus its steps. -->
            <div class="pnav-area-row">
                <button
                    type="button"
                    class="pnav-area"
                    data-testid="nav-module"
                    [class.has-action]="!!m.action && !collapsed"
                    [class.is-active]="m.id === activeModuleId"
                    [attr.aria-current]="m.id === activeModuleId ? 'page' : null"
                    [title]="collapsed ? m.label : null"
                    [attr.aria-label]="collapsed ? m.label : null"
                    (click)="onModuleClick(m.id)"
                >
                    <lucide-icon [name]="m.icon" [size]="16" aria-hidden="true"></lucide-icon>
                    <span class="pnav-area-label" *ngIf="!collapsed">{{ m.label }}</span>
                </button>
                <!-- A sibling, not a child: a button inside the row's button is not allowed. -->
                <ham-button
                    class="pnav-area-action"
                    data-testid="nav-module-action"
                    *ngIf="m.action && !collapsed"
                    variant="transparent"
                    size="xs"
                    [icon]="m.action.icon"
                    [hideText]="true"
                    (buttonClick)="moduleAction.emit(m.id)"
                    >{{ m.action.label }}</ham-button
                >
            </div>

            <div class="pnav-phases" *ngIf="!collapsed && isModuleExpanded(m)">
                <button
                    type="button"
                    class="pnav-step"
                    data-testid="nav-step"
                    *ngFor="let s of m.steps; trackBy: trackByStepId"
                    [attr.data-status]="s.status"
                    [attr.data-locked]="s.locked ? 'true' : null"
                    [class.is-active]="s.id === activeStepId"
                    [attr.aria-current]="s.id === activeStepId ? 'step' : null"
                    [attr.aria-disabled]="s.locked ? 'true' : null"
                    [hamTooltip]="s.locked ? s.lockedReason ?? '' : ''"
                    tooltipClass="abcp"
                    (click)="onStepClick(m.id, s)"
                >
                    <!-- The Jahresabschluss overview's status dot: teal with a check, amber, or an empty ring. -->
                    <span class="pnav-step-marker" aria-hidden="true">
                        <lucide-icon
                            *ngIf="s.status === 'done'"
                            name="check"
                            [size]="8"
                            [strokeWidth]="3"
                        ></lucide-icon>
                    </span>
                    <span class="pnav-step-label">{{ s.label }}</span>
                </button>
            </div>
        </div>
    </div>
</aside>
